/* eslint-disable no-underscore-dangle,import/no-mutable-exports,no-plusplus */
import { NewElementPlacement } from '@/features/editor/context/use-device-preview';
import { AiComponentVisualManifest } from '@/pkg/ai';
import { LoadingEnv } from '@/webapi/use-widget-catalog-api';
import { SelectedAgent } from '@/features/ai-agents/shared/models';

export interface Pair {
  key?: string;
  value: string;

  extra?: number | string;
}

export interface VisualEditSubChange extends Pair {
  kind: `text` | `attr` | `style` | `image` | `video`;
}
export interface VisualEdit {
  selector: string;
  subChanges: VisualEditSubChange[];
  version?: number;
}

export type HtmlMutationKind = 'replace' | 'appendBefore' | 'appendAfter';
export type AllMutationKind =
  | HtmlMutationKind
  | 'appendCss'
  | 'appendJs'
  | 'compound'
  | 'widget'
  | 'checkoutWidget'
  | 'rmCheckoutWidget'
  | 'appendFont'
  | `moveElem`
  | `automation`
  | `visualEdit`
  | `themeTest`
  | `clickTrack`
  | `priceTest`
  | `pageRedirect`;

export interface MutationKind {
  kind: AllMutationKind;
}

export interface DeclarativeBlock {
  order?: number;
  kind: AllMutationKind;
  selector: string;
  value:
    | string
    | CompoundChange
    | WidgetChange
    | CheckoutWidgetChange
    | MoveChange
    | AutomationChange
    | VisualEditChange
    | ThemeChange
    | PageRedirectChange;
}

export interface VisualEditChange {
  changes: VisualEdit[];
}

export interface AutomationChange {
  steps: AutomationStep[];
}

export interface AutomationStep {
  order: number;
  kind: AutomationStepKind;
  selector?: string;
  data?: any;
}

export type AutomationStepKind = `click` | `type` | `wait` | `scroll`;

export interface MoveChange {
  htmlKind: HtmlMutationKind;
  destSelector: string;
}

export interface CompoundChange {
  htmlKind: HtmlMutationKind;
  html: string;
  css: string;
  js: string;
  aiSessionId?: string;
  lastRunId?: string;
  aiFirstSessionId?: string;
  isAiComponent?: boolean;
  selectedAgent?: SelectedAgent;
  aiOrigin?: AiOriginAction;
  editManifest?: AiComponentVisualManifest;
  recsStrategies?: Record<string, LoadingEnv>;
}

export enum AiOriginAction {
  WIDGET_BUILDER = `widget_builder`,
  SECTION_MODIFIER = `section_modifier`,
}

export interface WidgetChange {
  htmlKind: HtmlMutationKind;
  env: Record<string, any>;
  widgetId: string;
  version?: string;
}

export type StickinessMode = `none` | `session` | `user` | undefined;

export interface PageRedirectChange {
  destUrl: string;
  redirectAfter: number;
  retainQueryParams?: boolean;
  stickinessMode?: StickinessMode;
}
export interface ThemeChange {
  targetThemeId: number;
}
export interface CheckoutWidgetChange {
  op: NewElementPlacement;
  opDependsOn?: string;
  props?: any;
  sectionId: string;
  mountPoint: string;
  widgetId?: string;
  version?: number;
}
